export default function redirectSpinner() {
  const el = document.createElement('div');
  el.id = 'sentry-redirect-spinner';
  el.innerHTML = `
    <div style="
      position: fixed;
      top: 0; left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(255,255,255,0.85);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999999;
      font-size: 20px;
      font-weight: 500;
      color: #333;
    ">
     Hang tight… we’re getting things back on track. <span style="margin-left: 10px;" class="sentry-redirect-spinner"></span>
    </div>
  `;

  document.body.appendChild(el);
}
